import {
  IFaq,
  IPlanBenefitTableDTO,
  PlanService as BasePlanService
} from 'react-angle-dashboard-components'
import { ISelectablePlan } from '../../interfaces/plan'

export class PlanService {
  planService: BasePlanService

  constructor(base: string) {
    this.planService = new BasePlanService(base)
  }

  getList() {
    return this.planService.getList()
  }

  async getSelectablePlans(data: any): Promise<ISelectablePlan[]> {
    const { plans } = await this.planService.getList(data)

    return plans.map((p) => ({
      deductible: p.deductible_individual_inn,
      deductibleFamily: p.deductible_family_inn,
      employerCostPerEmployee: Math.round(p.employer_premium_per_employee || 0),
      employeeCostPerEmployee: Math.round(p.employee_premium_per_employee || 0),
      id: p.plan_id,
      maxOOP: p.oop_max_individual_inn,
      maxOOPFamily: p.oop_max_family_inn,
      name: p.plan_name,
      selected: (p as any).selected,
      totalCostPerEmployee: Math.round(p.total_premium_per_employee || 0),
      totalEmployerCost: p.employer_premium,
      eligibleMember: p.eligible_member_types,
      startDate: p.start_date,
      endDate: p.end_date,
      tier: p.metal_tier,
      type: p.plan_type,
      doctorVisitCopay: p.doctor_visit_inn_copay,
      doctorVisitCopayType: p.doctor_visit_inn_copay_type,
      doctorVisitCoinsurance: p.doctor_visit_inn_coinsurance,
      specialistCopayType: p.specialist_inn_copay_type,
      specialistCopay: p.specialist_inn_copay,
      specialistCoinsurance: p.specialist_inn_coinsurance,
      urgentCareCopayType: p.urgent_care_inn_copay_type,
      urgentCareCopay: p.urgent_care_inn_copay,
      urgentCareCoinsurance: p.urgent_care_inn_coinsurance,
      genericDrug: p.rx_1
    }))
  }

  getSBC(
    planId: string
  ): Promise<{ faqs: IFaq[]; events: IPlanBenefitTableDTO[] }> {
    return this.planService.getSBC(planId).then((sbc) => ({
      faqs: sbc.faqs.map((f) => ({
        title: f.question,
        description: f.answer,
        section: {
          title: 'Why this matters',
          text: f.why_this_matters
        }
      })),
      events: sbc.events
    }))
  }
}
